import React, { type ReactNode } from "react";
import styles from "./DocumentName.module.css";

type DocumentNamePropsType = {
  inputValue?: string;
  handleNameInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorElement: ReactNode;
};

const DocumentName = ({
  inputValue = "",
  handleNameInputChange,
  errorElement,
}: DocumentNamePropsType) => {
  return (
    <label className={styles.label} htmlFor="documentName">
      <span className={styles.labelText}>Nombre del Documento</span>

      {errorElement}

      <input
        className={styles.input}
        type="text"
        name="documentName"
        id="documentName"
        value={inputValue}
        onChange={(e) => {
          handleNameInputChange(e);
        }}
        placeholder="Certificado de matrimonio"
      />
    </label>
  );
};

export default DocumentName;
